// extracted by mini-css-extract-plugin
module.exports = {"burger":"Burger_burger__YrJFV","burger--open":"Burger_burger--open__nh4RK"};